import AddFilter from 'modules/core/components/Filter/filters/AddFilter'

import { AgreementStatusFilter } from './AgreementStatusFilter'
import { EmployeeFilter } from './EmployeeFilter'
import { EvaluationsStatusFilter } from './EvaluationsStatusFilter'
import { FilterManager } from './FilterManager'
import { LegalEntityFilter } from './LegalEntityFilter'
import { ManagerFilter } from './ManagerFilter'
import { OnlyDirectReportsFilter } from './OnlyDirectReportsFilter'
import { ReviewerStrategyFilter } from './ReviewerStrategyFilter'
import { ScoreFilter } from './ScoreFilter'
import { TeamsFilter } from './TeamsFilter'
import { TenureFilter } from './TenureFilter'
import { WorkplaceFilter } from './WorkplaceFilter'
import { type FilterConfigProps, type FilterConfigType } from './filterConfig'
import { useFilterManager } from './useFilterManager'

export const Filters = {
  AddFilter,
  AgreementStatusFilter,
  EmployeeFilter,
  EvaluationsStatusFilter,
  FilterManager,
  ManagerFilter,
  OnlyDirectReportsFilter,
  ReviewerStrategyFilter,
  ScoreFilter,
  TeamsFilter,
  TenureFilter,
  WorkplaceFilter,
  LegalEntityFilter,
}

export { useFilterManager }
export type { FilterConfigType, FilterConfigProps }
